/** Every placeholder element in the document, in document order. */
export function findPlaceholders(model, predicate) {
    const root = model.document.getRoot();
    if (!root) {
        return [];
    }
    const found = [];
    for (const item of model.createRangeIn(root).getItems()) {
        if (item.is('element', 'placeholder') && (!predicate || predicate(item))) {
            found.push(item);
        }
    }
    return found;
}
export function findByInstanceId(model, instanceId) {
    const [element] = findPlaceholders(model, (candidate) => candidate.getAttribute('instanceId') === instanceId);
    return element || null;
}
